import { definePreset } from '@primeuix/themes';
import type { Preset } from '@primeuix/themes/types';
import Aura from '@primeuix/themes/aura';

// Structural preset only. Runtime primary tokens are bridged from CSS in
// src/assets/styles/_prime-bridge.scss so Prime follows the LPX brand tokens.
export const AURA_PRIME_PRESET = definePreset(Aura as Preset, {});
